export const container = {
  bgcolor: 'info.light',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  p: 2,
  gap: 2,
};

export const link = {
  fontWeight: 'bold',
  display: 'flex',
  gap: 1,
};
